<a class="skip-to-content-link" [href]="skipLinkPath">
    Skip to content
</a>
<main id="main">
    <router-outlet></router-outlet>
</main>
<imm-client-footer [partners]="partners"></imm-client-footer>